var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUsuarios = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Professionals") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inici/Menu-Obert",
  transform: "translate(-31.000000, -151.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-Lateral",
  transform: "translate(0.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Usuaris",
  transform: "translate(31.000000, 65.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5166135,13.5260073 L9.28156559,12.967033 L9.09183193,12.2065934 C9.68960285,11.614652 10.0991052,10.8014652 10.219978,9.96776557 C10.5518288,9.87399267 10.8082256,9.58974359 10.8529119,9.23369963 L10.9986919,8.06666667 C11.0294595,7.82051282 10.953273,7.57142857 10.7899116,7.38461538 C10.6946785,7.27545788 10.5738057,7.19194139 10.4404793,7.14139194 L10.4939564,6.04322344 L10.71226,5.82417582 C11.0404479,5.47545788 11.3129611,4.87545788 10.7437601,4.00659341 C10.3064204,3.33919414 9.56286955,3 8.53435194,3 C8.12851238,3 7.19376275,3 6.32347862,3.58461538 C3.83862697,3.63663004 3.50018314,4.79047619 3.50018314,5.91648352 C3.50018314,6.17875458 3.56391607,6.76776557 3.60567213,7.12454212 C3.45549683,7.17142857 3.31997279,7.25860806 3.21375124,7.37948718 C3.04745958,7.56776557 2.97054053,7.81831502 3.00130815,8.06739927 L3.14708806,9.23443223 C3.19543718,9.61391941 3.48406677,9.91355311 3.84888284,9.98461538 C3.96975564,10.7868132 4.35801371,11.5736264 4.92208676,12.156044 L4.71843441,12.9684982 L2.48411909,13.5274725 C1.02119198,13.8923077 0,15.2 0,16.7084249 C0,16.8688645 0.131128669,17 0.291559835,17 L13.7077076,17 C13.8688713,17 14,16.8681319 14,16.7076923 C14,15.2 12.978808,13.8923077 11.5166135,13.5260073",
  id: "Icon-Usuarios"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUsuarios);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_usuarios.e377b8afa7c0ee03f72259706569f260.svg";